import styled, { css, keyframes } from 'styled-components';

import { ToastType } from './ToastContext';

const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
`;

export const ToastContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999999;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 350px;
  width: 100%;

  @media (max-width: 768px) {
    top: 60px;
  }
`;

interface ToastItemProps {
  type: ToastType;
  isExiting?: boolean;
}

export const ToastItem = styled.div<ToastItemProps>`
  position: relative;
  display: flex;

  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  animation: ${slideIn} 0.3s ease forwards;
  width: 100%;

  ${(props) =>
    props.isExiting &&
    css`
      animation: ${slideOut} 0.3s ease forwards;
    `}

  ${(props) => {
    switch (props.type) {
      case 'success':
        return css`
          background-color: #f6fff9;
          border: 1px solid #24a148;
        `;
      case 'error':
        return css`
          background-color: #fff5f3;
          border: 1px solid #f4b0a1;
        `;
      default:
        return '';
    }
  }}
`;

export const IconContainer = styled.div<{ type: ToastType }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  margin-right: 12px;

  ${(props) => {
    switch (props.type) {
      case 'success':
        return css`
          background-color: #24a148;
          color: white;
        `;
      case 'error':
        return css`
          background-color: #ca5048;
          color: white;
        `;
      default:
        return '';
    }
  }}
`;

export const ToastContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ToastTitle = styled.p`
  font-weight: 500;
  font-size: 14px;
  color: #27303a;
`;

export const ToastCustomMessage = styled.p`
  font-weight: 400;
  font-size: 12px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  color: #999;

  &:hover {
    color: #666;
  }

  &:focus {
    outline: none;
  }
`;
